import { FC, useContext, useMemo } from 'react'
import { useQuery } from 'react-query'
import {
  QUERIES,
  WithChildren,
  createResponseContext,
  initialQueryResponse,
  stringifyRequestQuery,
} from '../../../../../../_metronic/helpers'
import { useModal } from '../../../../../components'
import { EscalaList } from '../../core/_models'
import { getEscalas } from '../../core/_requests'
import { ParamsMinhaEscala, useQueryRequest } from './QueryRequestProvider'

const QueryResponseContext = createResponseContext<EscalaList>(initialQueryResponse)

export const QueryResponseProvider: FC<WithChildren> = ({ children }) => {
  const { isOpen } = useModal()
  const { state } = useQueryRequest<ParamsMinhaEscala>()

  // `stringifyRequestQuery` só serializa paginação/ordenação/`search`; os
  // parâmetros do calendário (`params`) ficam de fora de propósito, porque a
  // listagem e o calendário consomem endpoints diferentes.
  const query = useMemo(() => stringifyRequestQuery(state), [state])

  const {
    isFetching,
    isError,
    refetch,
    data: response,
  } = useQuery([QUERIES.ESCALAS_PESSOAIS_LIST, query], () => getEscalas(query), {
    cacheTime: 0,
    keepPreviousData: true,
    refetchOnWindowFocus: false,
    enabled: !isOpen,
  })

  return (
    <QueryResponseContext.Provider
      value={{ isLoading: isFetching, isError, refetch, response, query }}
    >
      {children}
    </QueryResponseContext.Provider>
  )
}

export const useQueryResponse = () => useContext(QueryResponseContext)
